import StaffMemberResume from './StaffMemberResume.container';

export default StaffMemberResume;
